<template>
    <div style="width: 100%;height: 100%">
        <!-- 卡片视图 -->
        <el-card>
            <!-- 表格数据 -->
            <el-table :data="goodsList" border stripe v-loading="loading">
                <el-table-column type="index"></el-table-column>
                <el-table-column label="名称" prop="name" ></el-table-column>
                <el-table-column label="描述" prop="desc" ></el-table-column>
                <el-table-column label="用工单位" prop="emp_info.name" ></el-table-column>
                <el-table-column label="人力单位" prop="hr_info.name" ></el-table-column>

                <el-table-column label="合同">
                    <template slot-scope="scope">
                        <el-button type="primary"  @click="pdfTo(scope.row.contract_url)" v-if="scope.row.contract_url.length!==0">点击查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="create_time" >
                    <template slot-scope="scope">{{scope.row.create_time| dataFormat}}</template>
                </el-table-column>
                <el-table-column label="更新时间" prop="update_time" >
                    <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"  @click="toDetail(scope.row.id)" style="margin-top: 10px">员工列表</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini"  @click="toDelete(scope.row.id)" v-if="isHR">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
            ></el-pagination>
        </el-card>
        


    </div>
</template>

<script>

    export default {
        components:{
        },
        data () {
            return {
                queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                // 商品列表
                goodsList: [],
                // 商品总数
                total: 0,
                offset:0,
                oldoffset:0,
                isOpen:false,
                loading:true,
                input: '',
                selectname: 'name',
                door:{
                    value:false
                },
                name:"",
                desc:"",
                group_id:0,
                isHR:false
            }
        },
        created(){
            this.getList();
            var sign  = JSON.parse(window.sessionStorage.getItem('sign'));
            sign.forEach(e => {
                if(e=="hr"){
                   this.isHR = true;
                }
            });
        },
        methods:{
            async getList(){
                let that=this;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "get_phead_multi",
                        "ent": "task",
                        "info": {
                            "count":this.queryInfo.pagesize,
                            "offset":this.offset,
                        }
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.goodsList = res.data.data_list;
                    this.goodsList=this.goodsList.filter((e)=>{
                        return e.status !== 1
                    })
                    that.total = this.goodsList.length;
                    this.loading=false;
                    this.oldoffset=this.offset;
                    this.offset+=this.queryInfo.pagesize
                }else{
                    this.$message(res.msg);
                }
                this.loading=false;
            },
            add(id){
                this.door.value = true;
                this.group_id = id
            },
            handleCurrentChange (newSize) {
                this.queryInfo.pagenum = newSize;
                this.offset=(newSize-1)*this.queryInfo.pagesize;
                this.oldoffset=this.offset;
                this.getList()
            },
            handleSizeChange (newSize) {
                this.queryInfo.pagesize = newSize
                this.offset=0
                this.oldoffset=this.offset;
                this.getList()
            },
            toDetail(id){
                 this.$router.push({ name: 'task-detail', params: { id: id,identity:"re" }});
            },
            pdfTo(url){
                console.log(url)
                window.open(url);
            },
              async editTask(id,status){
                console.log(id,status);
                 const { data: res } = await this.$http.post('',
                    {
                       "oper": "edit",
                        "ent": "task",
                        "info": {
                            id,
                            status
                        }
                    }
                )
                console.log(res)
                if(res.code==0){
                    return true;
                }else{
                    this.$message(res.msg);
                }
            },
            toDelete(id){
                 this.$confirm('此操作将移除任务 , 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    var status = 1;
                    var res = await this.editTask(id,status);
                    if(res){
                        this.offset = this.oldoffset;
                        this.getList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消发布'
                    });          
                    
                });
            }
        }
    }
</script>

<style>
    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }
    .el-select .el-input {
        width: 130px;
    }
    .select{
        height: 125px !important;
    }
</style>
